/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  color: ouiStyle.Constants.Colors.greyDarkest,
  listStyleType: ouiStyle.Constants.ListStyleTypeProps.unordered,
  marginLeft: 3,
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const SanityBulletListContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <ul
      css={css}
    >
      {children}
    </ul>
  );
};
